import { tableBodyVariants } from 'animations/motionConfig';
import { useReducedMotion } from 'animations/useReducedMotion';
import { motion } from 'framer-motion';
import React, { FC, ReactNode } from 'react';

interface AnimatedTableBodyProps {
    children: ReactNode;
    loading?: boolean;
    itemCount?: number;
    animationKey?: string;
    className?: string;
}

const AnimatedTableBody: FC<AnimatedTableBodyProps> = ({
    children,
    loading = false,
    itemCount = 0,
    animationKey = 'default',
    className = '',
}) => {
    const reducedMotion = useReducedMotion();
    const childCount = React.Children.count(children);
    const shouldAnimate = !reducedMotion && !loading && (itemCount > 0 || childCount > 0);

    if (reducedMotion) {
        return <tbody className={className}>{children}</tbody>;
    }

    return (
        <motion.tbody
            key={animationKey}
            className={className}
            variants={tableBodyVariants}
            initial="hidden"
            animate={shouldAnimate ? 'show' : 'hidden'}
        >
            {children}
        </motion.tbody>
    );
};

export default AnimatedTableBody;
